<template>
    <div class="o-movie-schedule">
        <span class="movie-schedule-title">
            {{ $t('o-movie-schedule.buy-tickets') }}
        </span>
        <ODateSelector
            v-model="selectedDate"
            :list="movieTime"
            class="movie-schedule-date-selector"
        />
        <OMovieSlot
            v-for="slot in movieBySelectedDate"
            :key="slot.id"
            :item="slot"
            @onBuyTicket="onBuyTicket"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ODateSelector from '../../organisms/o-date-selector';
import OMovieSlot from '../../unique-organisms/o-movie-slot';

export default {
    name: 'OMovieSchedule',
    data() {
        return {
            id: this.$route.query.movieId,
            selectedDate: null
        }
    },
    components: {
        OMovieSlot,
        ODateSelector
    },
    computed: {
        ...mapGetters([
            'getMovieData'
        ]),
        movieData() {
            return this.getMovieData(this.id).reverse();
        },
        movieBySelectedDate() {
            return this.movieData.filter(el => el.ShowDate === this.selectedDate);
        },
        movieTime() {
            return Array.from(new Set(this.movieData.map(s => s.ShowDate))).map((el, idx) => ({
                id: idx,
                value: el
            })).slice(0, 7) || [];
        }
    },
    watch: {
        movieTime: {
            handler(value) {
                if (value.length) this.selectedDate = this.movieTime[0].value;
            },
            immediate: true
        }
    },
    methods: {
        onBuyTicket(data) {
            const payload = {
                ...data,
                date: this.selectedDate
            };
            this.$emit('onBuyTicket', payload);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
